"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CheckRounded_1 = __importDefault(require("@mui/icons-material/CheckRounded"));
const DropdownButton = ({ children, handleOnClick, isDisabled, isActive, label, icon }) => {
    return (react_1.default.createElement("button", { "aria-label": label, id: "dropdownMenuButton", title: label, type: "button", onClick: handleOnClick, disabled: isDisabled, className: `btn dropdown-button ${isActive ? 'is-active' : ''}` },
        react_1.default.createElement("div", { className: "dropdown-button-label" },
            icon && icon,
            children || label),
        isActive && react_1.default.createElement(CheckRounded_1.default, { className: "dropdown-button-icon" })));
};
exports.default = DropdownButton;
